export const extractDomain = (url) => {
    if (!url) return '';

    // Remove protocol
    let domain = url.replace(/^https?:\/\//, '');
    // Remove path and query parameters
    domain = domain.split('/')[0];
    // Remove port
    domain = domain.split(':')[0];
    // Remove www prefix
    domain = domain.replace(/^www\./, '');

    return domain;
};

/**
 * The page URL without its query string or fragment, for the alias's Site URL.
 * Those parts are where login and signup pages carry redirect targets and
 * tracking parameters, which identify nothing about the site and routinely
 * push the URL past the 200 characters the column holds.
 */
export const siteUrlFromPageUrl = (url) => (url || '').split(/[?#]/)[0];

/**
 * Extract the base domain from a URL or domain string.
 * e.g., "app.sitename.com" -> "sitename.com"
 *       "www.sitename.co.uk" -> "sitename.co.uk"
 */
export const extractBaseDomain = (url) => {
    const fullDomain = extractDomain(url);
    if (!fullDomain) return '';

    const parts = fullDomain.split('.');

    // Handle common two-part TLDs (co.uk, com.au, etc.)
    const twoPartTLDs = ['co.uk', 'com.au', 'co.nz', 'co.jp', 'com.br', 'co.za'];
    const lastTwoParts = parts.slice(-2).join('.');

    if (twoPartTLDs.includes(lastTwoParts) && parts.length >= 3) {
        // Return last 3 parts for two-part TLDs (e.g., sitename.co.uk)
        return parts.slice(-3).join('.');
    } else if (parts.length >= 2) {
        // Return last 2 parts for normal domains (e.g., sitename.com)
        return parts.slice(-2).join('.');
    }

    return fullDomain;
};

/**
 * Check if two URLs/domains match, considering subdomains.
 * Returns true if:
 * - They have the same base domain (sitename.com matches app.sitename.com)
 * - OR one domain is contained in the other
 */
export const domainsMatch = (url1, url2) => {
    if (!url1 || !url2) return false;

    const domain1 = extractDomain(url1);
    const domain2 = extractDomain(url2);

    // Exact match
    if (domain1 === domain2) return true;

    // Check if one contains the other (for subdomains)
    if (domain1.includes(domain2) || domain2.includes(domain1)) return true;

    // Check base domain match (sitename.com matches app.sitename.com)
    const base1 = extractBaseDomain(url1);
    const base2 = extractBaseDomain(url2);

    return base1 === base2 && base1 !== '';
};

export const copyToClipboard = (text, onSuccess) => {
    navigator.clipboard.writeText(text).then(() => {
        onSuccess && onSuccess(`Copied to clipboard: ${text}`);
    }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        onSuccess && onSuccess(`Copied to clipboard: ${text}`);
    });
};

export const parseUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
        url: params.get('url') || '',
        title: params.get('title') || ''
    };
};